<template>
  <ModalDialog
    :model-value="show"
    persistent
    :title="t('Meetings.availability.warningsDialog.title')"
    max-width="640px"
    @closed="emit('confirm', false)"
  >
    <i18n-t keypath="Meetings.availability.warningsDialog.description" tag="p" class="mb-3 txt-body-m">
      <template #here>
        <router-link :to="{ name: 'meetingsMyMeetings' }" class="text-primary hover:underline">
          {{ t('Meetings.availability.warningsDialog.here') }}
        </router-link>
      </template>
      <template #strong>
        <strong>{{ t('Meetings.availability.warningsDialog.description_bold') }}</strong>
      </template>
    </i18n-t>
    <ul class="list-disc pl-5 txt-body-m" data-testid="meetings-config-warnings-list">
      <li v-for="(warning, index) in warnings" :key="index">{{ warning }}</li>
    </ul>
    <div class="mt-6 flex justify-end gap-3">
      <button class="btn-outline-neutral-s" data-testid="meetings-config-warnings-cancel" @click="emit('confirm', false)">
        {{ t('Meetings.availability.warningsDialog.cancel') }}
      </button>
      <button class="btn-primary-destructive-s" data-testid="meetings-config-warnings-confirm" @click="emit('confirm', true)">
        {{ t('Meetings.availability.warningsDialog.confirm') }}
      </button>
    </div>
  </ModalDialog>
</template>

<script setup lang="ts">
import { ModalDialog } from '@ramp106/omrjs-core-ui'
import { useI18n } from 'vue-i18n'

defineProps<{
  show: boolean
  warnings: string[]
}>()

const emit = defineEmits<{
  (e: 'confirm', value: boolean): void
}>()

const { t } = useI18n()
</script>
